import { Fragment } from 'react';
import H5TopBar from '../H5TopBar';
import CardTypeA from './CardTypeA';
import CardTypeB from './CardTypeB';
import CardTypeD from './CardTypeD';
import CardTypeE from './CardTypeE';

enum CardTypesEnum {
    /** 产品系列3级类目样式 */
    Product = 1,
    /** 场景样式 */
    Scene = 2,
    /** 服务支持样式 */
    Service = 3,
    /** 纯文字样式样式 */
    TextTitle = 5,
    /** 产品系列4级类目样式 */
    ProductCategory = 6,
}

interface Props {
    itemId?: string;
    title: string;
    prefixCls: string;
    item: any;
}

const SubClientList: React.FC<Props> = ({ prefixCls, title, itemId, item }) => {
    return (
        <Fragment key={itemId}>
            <H5TopBar prefixCls={prefixCls} title={title} />
            {[CardTypesEnum.Product].includes(item.type) && <CardTypeA prefixCls={prefixCls} item={item} title={title} />}
            {[CardTypesEnum.Scene, CardTypesEnum.Service].includes(item.type) && (
                <CardTypeB prefixCls={prefixCls} item={item} title={title} isService={item.type === CardTypesEnum.Service} />
            )}
            {[CardTypesEnum.TextTitle].includes(item.type) && <CardTypeD prefixCls={prefixCls} item={item} title={title} />}
            {[CardTypesEnum.ProductCategory].includes(item.type) && <CardTypeE prefixCls={prefixCls} item={item} title={title} />}
        </Fragment>
    );
};
export default SubClientList;
